import {memo, useCallback} from 'react';

import styled from 'styled-components';

import {getUserFormattedAddress} from '~/shared/services/addressHelper';
import {getLocalizationService} from '~/shared/services/localisationService';
import {Address, LocalAddress} from '~/shared/store/models';
import {flexCenterVertically} from '~/shared/theme/FlexLayout';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {smallBold, smallRegular} from '~/shared/theme/typography';
import {media} from '~/shared/theme/media';

const AddressButtonText = styled.div`
  ${flexCenterVertically}
  ${smallBold}
  color: ${({theme}) => theme.colors.charcoal80};
  /* stylelint-disable-next-line */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  ${flipOnLTR`
    text-align: right;
  `}
  ${media.minLargeMobile`
    ${smallRegular}
  `}
  max-height: 32px;
  overflow: hidden;
`;

const ButtonText = ({
  activeAddress,
  isAddingFirstAddress,
}: {
  activeAddress: Address | LocalAddress | undefined;
  isAddingFirstAddress?: boolean;
}) => {
  const {t} = getLocalizationService();

  const getActiveAddress = useCallback(() => {
    if (activeAddress) {
      const userFormattedAddress = getUserFormattedAddress(activeAddress);
      return userFormattedAddress || isAddingFirstAddress || t('add_address');
    }
    return t('please_add_address');
  }, [activeAddress, isAddingFirstAddress, t]);

  return (
    <AddressButtonText>
      {getActiveAddress()}
    </AddressButtonText>
  );
};

export default memo(ButtonText);
